import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const DocumentHead = ({ title, description }) => (
	<Helmet>
		<meta charSet="utf-8" />
		<title>{title}</title>
		<meta name="title" content={title} />
		<meta name="description" content={description} />
		<meta name="viewport" content="width=device-width, initial-scale=1.0" />
	</Helmet>
);

DocumentHead.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
	title: state.head.title,
	description: state.head.description,
});

export default connect(mapStateToProps)(DocumentHead);



// WEBPACK FOOTER //
// ./src/documentHead.js